import React from "react";
import "./Tag.css";

// Icon components
export const Icons = {
  triangle: (
    <svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor">
      <path d="M16 6 L6 26 L26 26 Z" />
    </svg>
  ),
  circle: (
    <svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor">
      <circle cx="16" cy="16" r="14" />
    </svg>
  ),
  square: (
    <svg width="16" height="16" viewBox="0 0 32 32" fill="currentColor">
      <path d="M28 10v12c0 2.21-1.79 4-4 4H8c-2.21 0-4-1.79-4-4V10c0-2.21 1.79-4 4-4h16c2.21 0 4 1.79 4 4zM8 10h16v12H8V10z" />
    </svg>
  ),
};

// Color mapping using pastel colors from Carbon Design System
export const colors = {
  purple: {
    bg: "rgba(136, 65, 150, 0.12)",
    border: "rgba(136, 65, 150, 0.3)",
    text: "#884196",
  },
  pink: {
    bg: "rgba(183, 66, 209, 0.12)",
    border: "rgba(183, 66, 209, 0.3)",
    text: "#B742D1",
  },
  blue: {
    bg: "rgba(115, 174, 238, 0.12)",
    border: "rgba(115, 174, 238, 0.3)",
    text: "#5a8fc5",
  },
};

/**
 * Tag component - Carbon Design System style with pastel colors
 */
export const Tag = ({
  children,
  color = "blue",
  icon: Icon,
  size = "small",
}) => {
  const colorStyles = colors[color] || colors.blue;

  const sizes = {
    small: {
      padding: "2px 8px",
      fontSize: "0.75rem",
      borderRadius: "4px",
    },
    medium: {
      padding: "2px 10px",
      fontSize: "0.875rem",
      borderRadius: "4px",
    },
    large: {
      padding: "4px 12px",
      fontSize: "1rem",
      borderRadius: "6px",
    },
  };

  const sizeStyles = sizes[size] || sizes.medium;

  return (
    <span
      className="ui tag carbon-tag"
      style={{
        backgroundColor: colorStyles.bg,
        color: colorStyles.text,
        border: `1px solid ${colorStyles.border}`,
        padding: sizeStyles.padding,
        borderRadius: sizeStyles.borderRadius,
        fontSize: sizeStyles.fontSize,
        fontWeight: "400",
        lineHeight: "1.5",
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
      }}
    >
      {Icon && (
        <span style={{ display: "inline-flex", alignItems: "center" }}>
          {Icon}
        </span>
      )}
      {children}
    </span>
  );
};

/**
 * TagGroup component - container for multiple tags
 */
export const TagGroup = ({ children, className = "", style = {} }) => {
  return (
    <div
      className={`tags ${className}`}
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        marginTop: "8px",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default Tag;
